import { InvoiceFrequencyType } from 'entities/Invoice';
import { UnitType } from 'entities/Contract';

export enum PaymentFrequencySetting {
  ONLY_REGULAR = 'only-regular',
  ONLY_ENTIRE_PERIOD = 'only-entire',
  ALL = 'all',
}

export enum RecurringInvoiceFrequencySetting {
  REGULAR = 'regular',
  MIN_CONTRACT_DURATION = 'min-contract-duration',
}

export enum AccountTypeSetting {
  PERSONAL = 'only-personal',
  BUSINESS = 'only-business',
  ALL = 'all',
}

export enum LoyaltyUserSetting {
  ONLY_NEW = 'only-new',
  ONLY_OLD = 'only-old',
  ALL = 'all',
}

export type UnitTypeSetting = UnitType | 'All';

export interface RentOptionDocument {
  rentOptionId: string;
  label: string;
  isDefault: boolean;
  isSpecialPromotion: boolean;
  showAsPromotion: boolean;
  invoiceFrequencyType: InvoiceFrequencyType;
  paymentFrequencySetting: PaymentFrequencySetting;
  recurringInvoiceFrequencySetting: RecurringInvoiceFrequencySetting;
  accountTypeSetting: AccountTypeSetting;
  loyaltyUserSetting: LoyaltyUserSetting;
  minContractDuration: number;
  order: number;
  warehouseIds?: string[];
  discountKeys: Nullable<string[]>;
  description?: string;
  extendedDescription?: string;
  dateFrom?: string;
  dateTo?: string;
  unitSizes: Nullable<string[]>;
  unitTypeSetting: UnitTypeSetting;
  isActive: boolean;
}
